import { Chip, SxProps } from "@mui/material";
import { WasteClassification } from "generated-graphql/graphql";

import { prettyPrintWasteClassification } from "./Facilities/Facility/prettyPrintWasteClassification";

// Semantic, low-contrast outlined chips per the design system. Severity rises
// neutral → info → warning → error so the classification reads at a glance.
const CLASSIFICATION_COLOR: Record<WasteClassification, "default" | "info" | "warning" | "error"> =
  {
    [WasteClassification.Nonhazardous]: "default",
    [WasteClassification.StateRegulated]: "info",
    [WasteClassification.RcraHazardous]: "warning",
    [WasteClassification.RcraAcutelyHazardous]: "error",
  };

interface WasteClassificationChipProps {
  classification: WasteClassification | null | undefined;
  sx?: SxProps;
}

/** The waste stream's classification as an at-a-glance semantic chip. */
export function WasteClassificationChip({ classification, sx }: WasteClassificationChipProps) {
  const label = prettyPrintWasteClassification(classification);
  if (!label) return null;
  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      color={classification ? CLASSIFICATION_COLOR[classification] : "default"}
      sx={sx}
    />
  );
}
